import React, { useEffect } from "react";
import { Container, Row, Col, Alert } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faPlug } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from '@themesberg/react-bootstrap';

import { DeviceTable } from '../../commons/device/partials/DeviceTable';

export default () => {
  useEffect(() => {
    document.title = "Quản lý thiết bị USB"
  }, []);

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Quản lý thiết bị và nhân viên</Breadcrumb.Item>
            <Breadcrumb.Item active>Thiết bị USB</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Quản lý thiết bị USB</h4>
          <p className="mb-0">Quản lý và gán nhân viên cho các thiết bị USB</p>
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col>
            <Alert variant="warning">
              <Alert.Heading as="h5">⚡ Thiết bị USB tự động được tạo khi ghim vào</Alert.Heading>
              <p className="mb-0">
                Không cần thêm thiết bị thủ công — chip USB ghim vào sẽ tự đăng ký với tên trùng mã thiết bị.
                Muốn đổi tên thiết bị thì phải <strong>nạp lại code cho chip</strong> với mã mới, sau đó xoá thiết bị cũ ở bảng dưới.
              </p>
            </Alert>
            <DeviceTable />
          </Col>
        </Row>
      </Container>
    </>
  );
};
